import React from "react";
import { ProductCardProps } from "./ProductCard";
import { formatPrice, handleLogin } from "../../utils/common";
import { handleContactUs, getYourPriceLabel, showListPriceLabel } from "Utils/activityHelper";
interface PriceWidgetProps extends ProductCardProps {
  size?: 'small' | 'medium' | 'large' ;
  placeholder?: string;
}
const PriceWidget: React.FC<PriceWidgetProps> = (props) => {
  const { product, loginState, placeholder, previewData, isOrderPreviewFlag } = props;
  const {
    listPrice,
    promoPrice,
    finalPrice,
    priceStatus,
    level1Qty,
    level1Price,
    level2Qty,
    level2Price,
    priceType,
  } = product;

  const priceItems = () => {
    if (priceStatus === "ContactUs") {
      return (
        <div className="textLink" onClick={() => {
          handleContactUs(loginState)
        }}>
          联系我们
        </div>
      );
    }
    if (priceStatus === "LoginRequired")
      return (
        <div className="textLink" onClick={handleLogin}>登录可见</div>
      );
    if (priceStatus === "Preview")
      return <div className="lightText">{formatPrice(finalPrice)}</div>;

    if (placeholder === "cartItem") {
      return (
        <>
          {promoPrice && (
            <span className={`primaryText priceItem`}>{formatPrice(promoPrice)}</span>
          )}
          {promoPrice !== '0.00' && finalPrice && (
            <span className={`primaryText priceItem`}>
              <span style={{fontSize: '12px', paddingRight: '4px'}}>折后</span>
              <span style={{fontWeight: 600}}>{formatPrice(finalPrice)}</span>
              </span>
          )}
  
          {level1Qty && level1Price && (
            <span className="lightText priceItem font13">
              <span>
                {" "}
                {level1Qty}
                {"件"}
              </span>
              <span style={{ paddingLeft: "5px" }}>
                {formatPrice(level1Price)}
              </span>
            </span>
          )}
          {level2Qty && level2Price && (
            <span className="lightText priceItem font13">
              <span>
                {level2Qty}
                {"件"}
              </span>
              <span style={{ paddingLeft: "5px" }}>
                {formatPrice(level2Price)}
              </span>
            </span>
          )}
        </>
      );
    }
    return (
      <>
        {finalPrice !== null && finalPrice !== undefined && finalPrice !== "" && (
          <span className={`primaryText priceItem`}>{getYourPriceLabel({priceType, previewData, isOrderPreviewFlag})}{formatPrice(finalPrice)}</span>
        )}

        {level1Qty && level1Price && (
          <span className="lightText priceItem font13">
            <span>
              {" "}
              {level1Qty}
              {"件"}
            </span>
            <span style={{ paddingLeft: "5px" }}>
              {formatPrice(level1Price)}
            </span>
          </span>
        )}
        {level2Qty && level2Price && (
          <span className="lightText priceItem font13">
            <span>
              {level2Qty}
              {"件"}
            </span>
            <span style={{ paddingLeft: "5px" }}>
              {formatPrice(level2Price)}
            </span>
          </span>
        )}
      </>
    );
  }

  console.log("PriceWidget previewData", previewData);
  return (
    <div className= {`priceWrapper ${props.size || ''}`}>
      {listPrice && (
        <div>
          {showListPriceLabel({previewData, isOrderPreviewFlag})}
          <span className="priceItem lightText lineThrough">
            {formatPrice(listPrice) || ""}
          </span>
          </div>
      )}
      {priceItems()}
    </div>
  );
};

export default PriceWidget;
